import axios from 'axios'
import exceptionHandler from '../common/exception-handler'

export default {
  login (email, password, userCompany) {
    return axios.post('/api/session/login', { email: email, password: password, companyId: userCompany })
      .then(res => res.data)
      .catch(error => exceptionHandler.parse(error))
  },
  getStatus (companyId) {
    return axios.get('/api/session/status', { params: { companyId: companyId } })
      .then(res => res.data)
      .catch(error => exceptionHandler.parse(error))
  },
  logout () {
    return axios.get('/api/session/logout')
      .catch(error => exceptionHandler.parse(error))
  },
  setLastUserCompany (email, companyId) {
    localStorage.lastCompanyId = companyId
    localStorage[`user_company::${email}`] = companyId
  },
  getLastUserCompany (email) {
    return localStorage[`user_company::${email}`]
  },
  getLastCompanyId () {
    return localStorage.lastCompanyId
  },
  sendPasswordReset (email) {
    return axios.post('/api/users/sendPasswordReset', { emailAddress: email })
      .catch(error => exceptionHandler.parse(error))
  },
  validateToken (userId, inviteToken) {
    return axios.get('/api/users/isValidInviteToken', { params: { userId, inviteToken } })
      .then(res => res.data)
      .catch(error => exceptionHandler.parse(error))
  },
  setPassword (userId, inviteToken, newPassword) {
    return axios.post('/api/users/setPasswordWithToken', { userId, inviteToken, newPassword })
      .catch(error => exceptionHandler.parse(error))
  }

}
